import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PERSON_SELECT_NOT_LISTED } from '@wundo/ui';
import { answerManagerQuestion, setColleagueRelationship } from '@/lib/colleagues.ts';

export interface ManagerAnswer {
  userId: string;
  /** A colleague's id, or "not listed". */
  choice: string;
}

/**
 * Store the answer to "who is your manager?": a colleague becomes the manager,
 * and either way the question counts as answered.
 */
export function useManagerAnswer() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ userId, choice }: ManagerAnswer) => {
      if (choice !== PERSON_SELECT_NOT_LISTED) {
        await setColleagueRelationship(userId, choice, 'manager');
      }
      await answerManagerQuestion(userId);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['currentUser'] });
      await queryClient.invalidateQueries({ queryKey: ['oneOnOneColleagues'] });
      await queryClient.invalidateQueries({ queryKey: ['oneOnOneColleague'] });
    },
  });
}
